import { CASES } from './constants';

/**
 * Action to update users in the store.
 *
 * This action is dispatched to update the user state in the Redux store.
 * It takes a payload containing the new users' data.
 *
 * @param {Object} payload - The new users data to be stored.
 * @returns {Object} The action object with type and payload.
 **/
export const updateUsers = (payload) => {
    return { type: CASES.UPDATE_USERS, payload };
};

/**
 * Action to update the users search form.
 *
 * This action is dispatched to update the search form state in the Redux store.
 * It takes a key and data to update the specific field in the search form.
 *
 * @param {string} key - The key of the search form field to be updated.
 * @param {any} data - The new data to be set for the specified field.
 * @returns {Object} The action object with type and payload.
 **/
export const updateUsersSearchForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_USERS_SEARCH_FORM,
        payload: { key, data },
    };
};

export const updateUserForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_USER_FORM,
        payload: { key, data },
    };
};

/**
 * Action to clear the users search form.
 *
 * This action is dispatched to reset the search form state in the Redux store.
 * It clears all the fields in the search form.
 *
 * @returns {Object} The action object with type and payload.
 **/
export const clearUsers = () => {
    return { type: CASES.CLEAR_USERS, payload: {} };
};

export const clearUserForm = () => {
    return { type: CASES.CLEAR_USER_FORM, payload: {} };
};
